import script from "./NextHours.vue?vue&type=script&setup=true&lang=js"
export * from "./NextHours.vue?vue&type=script&setup=true&lang=js"

import "./NextHours.vue?vue&type=style&index=0&id=2484ea60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2484ea60"]])

export default __exports__